// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles-module__toolbar___GrCZf","button":"styles-module__button___267iM","active":"styles-module__active___11ZA2","toolbar-item":"styles-module__toolbar-item___xb4pr"};